import { fieldErrorId } from '@/features/people/lib/field-a11y';

/** The error line under a dialog field; `invalidProps` points the field at it. [HW-1008] */
export function FieldError({ id, error }: { id: string; error: string | undefined }) {
  if (!error) return null;
  return (
    <p id={fieldErrorId(id)} className="text-sm text-destructive">
      {error}
    </p>
  );
}
